import _ from 'lodash'

export function findKey<T>(
  object: { [key: string]: T },
  findFunc: (arg0: T) => boolean
) {
  return _.findKey(object, findFunc)
}
